import { ITerm } from './index';

export const TERM_CREDIT_LOAN: ITerm[] = [
  {
    text: '본인인증 필수 항목 모두 동의',
    guideText: '',
    required: true,
    termCd: '',
    type: 'termGroup',
    subTextItem: [
      {
        title: '통신사 이용 약관',
        termCd: 'CERT_DETAIL_1',
        path: '/terms/CERT_DETAIL_1.html',
      },
      {
        title: '개인정보취급동의',
        termCd: 'CERT_DETAIL_2',
        path: '/terms/CERT_DETAIL_2.html',
      },
      {
        title: '고유식별정보처리동의',
        termCd: 'CERT_DETAIL_3',
        path: '/terms/CERT_DETAIL_3.html',
      },
      {
        title: '본인확인 서비스 이용약관',
        termCd: 'CERT_DETAIL_4',
        path: '/terms/CERT_DETAIL_4.html',
      },
      {
        title: '개인정보 제3자 제공 동의',
        termCd: 'CERT_DETAIL_5',
        path: '/terms/CERT_DETAIL_5.html',
      },
    ],
  },
  {
    text: '서비스 필수 항목 모두 동의',
    guideText: '',
    required: true,
    termCd: '',
    type: 'termGroup',
    subTextItem: [
      {
        title: '서비스 이용 약관 동의',
        termCd: 'SERVICE_1',
        path: '/terms/SERVICE_1.html',
      },
      {
        title: '개인(신용)정보 수집·이용 동의',
        termCd: 'SERVICE_2',
        path: '/terms/SERVICE_2.html',
      },
      {
        title: '개인(신용)정보 제3자 제공 동의',
        termCd: 'SERVICE_3',
        path: '/terms/SERVICE_3.html',
      },
    ],
  },
  {
    text: '금융기관 필수 항목 모두 동의',
    guideText: '',
    required: true,
    termCd: '',
    type: 'termGroup',
    subTextItem: [
      {
        title: '개인(신용)정보 수집·이용 동의(금융기관)',
        termCd: 'FINANCE_1',
        path: '/terms/FINANCE_1.html',
      },
      {
        title: '개인(신용)정보 제3자 제공 동의(금융기관)',
        termCd: 'FINANCE_2',
        path: '/terms/FINANCE_2.html',
      },
      {
        title: '개인(신용)정보 수집·이용·제공·조회 동의(금융기관)',
        termCd: 'FINANCE_3',
        path: '/terms/FINANCE_3.html',
      },
      {
        title: '고유식별정보 처리 동의(금융기관)',
        termCd: 'FINANCE_4',
        path: '/terms/FINANCE_4.html',
      },
      {
        title: '개인(신용)정보 수집·이용·제공·조회 동의서(신용보증 신청용)',
        termCd: 'FINANCE_5',
        path: '/terms/FINANCE_5.html',
      },
      {
        title:
          '개인(신용)정보 수집·이용·제공·조회 동의서(비금융 대안정보 활용 신청용)',
        termCd: 'FINANCE_6',
        path: '/terms/FINANCE_6.html',
      },
      {
        title: '개인(신용)정보 제3자 제공 동의서(통신정보 활용 신청용)',
        termCd: 'FINANCE_7',
        path: '/terms/FINANCE_7.html',
      },
      {
        title:
          '개인(신용)정보 이용 및 제3자 제공 동의서(자동이체 정보 활용 신청용)',
        termCd: 'FINANCE_8',
        path: '/terms/FINANCE_8.html',
      },
      {
        title: '계약체결 이행 등을 위한 필수 동의(서울보증보험)',
        termCd: 'FINANCE_9',
        path: '/terms/FINANCE_9.html',
      },
      {
        title: '개인(신용)정보 수집·이용·제공 동의서(우리은행)',
        termCd: 'FINANCE_10',
        path: '/terms/FINANCE_10.html',
      },
      {
        title: '개인(신용)정보 수집·이용·제공·조회 동의서(우리은행)',
        termCd: 'FINANCE_11',
        path: '/terms/FINANCE_11.html',
      },
      {
        title:
          '개인(신용)정보 수집·이용 동의서(여신금융거래)(KB 리브모바일 통신관련 정보이용)',
        termCd: 'FINANCE_12',
        path: '/terms/FINANCE_12.html',
      },
      {
        title:
          '자동이체정보 개인(신용)정보 이용·제공·조회 동의서(금융결제원-KCB)',
        termCd: 'FINANCE_13',
        path: '/terms/FINANCE_13.html',
      },
      {
        title:
          '개인(신용)정보 수집·이용·제공·조회 및 제3자 제공동의서(대안정보-KCB)',
        termCd: 'FINANCE_14',
        path: '/terms/FINANCE_14.html',
      },
      {
        title: '개인(신용)정보 제3자 제공 동의서(대안정보-다날)',
        termCd: 'FINANCE_15',
        path: '/terms/FINANCE_15.html',
      },
      {
        title:
          '개인(신용)정보 수집·이용·제공·조회 동의서(금융결제원 정보활용-교보SBI저축은행)',
        termCd: 'FINANCE_17',
        path: '/terms/FINANCE_17.html',
      },
      {
        title: '계약_체결·이행_등을_위한_상세_동의서(개인금융성_신용보험용)',
        termCd: 'FINANCE_20',
        path: '/terms/FINANCE_20.html',
      },
      {
        title: '개인(신용)정보_이용_및_제3자_제공_동의서[금융결제원]',
        termCd: 'FINANCE_21',
        path: '/terms/FINANCE_21.html',
      },
    ],
  },
  {
    text: '선택 약관 모두 동의(이벤트 포함)',
    guideText: '',
    required: false,
    termCd: '',
    type: 'termGroup',
    subTextItem: [
      {
        title: '개인(신용)정보 수집·이용 동의서(보증료 우대 서비스)',
        termCd: 'FINANCE_18',
        path: '/terms/FINANCE_18.html',
      },
      {
        title: '개인(신용)정보 수집·이용 동의서(상품서비스 안내 등)',
        termCd: 'FINANCE_19',
        path: '/terms/FINANCE_19.html',
      },
    ],
  },
];
export const TERM_MTG_LOAN: ITerm[] = [
  {
    text: '[주담대] 본인인증 필수 항목 모두 동의',
    guideText: '',
    required: true,
    termCd: '',
    type: 'termGroup',
    subTextItem: [
      {
        title: '통신사 이용 약관',
        termCd: 'CERT_DETAIL_1',
        path: '/terms/CERT_DETAIL_1.html',
      },
      {
        title: '개인정보취급동의',
        termCd: 'CERT_DETAIL_2',
        path: '/terms/CERT_DETAIL_2.html',
      },
      {
        title: '고유식별정보처리동의',
        termCd: 'CERT_DETAIL_3',
        path: '/terms/CERT_DETAIL_3.html',
      },
      {
        title: '본인확인 서비스 이용약관',
        termCd: 'CERT_DETAIL_4',
        path: '/terms/CERT_DETAIL_4.html',
      },
      {
        title: '개인정보 제3자 제공 동의',
        termCd: 'CERT_DETAIL_5',
        path: '/terms/CERT_DETAIL_5.html',
      },
    ],
  },
  {
    text: '[주담대] 서비스 필수 항목 모두 동의',
    guideText: '',
    required: true,
    termCd: '',
    type: 'termGroup',
    subTextItem: [
      {
        title: '서비스 이용 약관 동의',
        termCd: 'SERVICE_1',
        path: '/terms/SERVICE_1.html',
      },
      {
        title: '개인(신용)정보 수집·이용 동의',
        termCd: 'SERVICE_2',
        path: '/terms/SERVICE_2.html',
      },
      {
        title: '개인(신용)정보 제3자 제공 동의',
        termCd: 'SERVICE_3',
        path: '/terms/SERVICE_3.html',
      },
    ],
  },
  {
    text: '[주담대] 금융기관 필수 항목 모두 동의',
    guideText: '',
    required: true,
    termCd: '',
    type: 'termGroup',
    subTextItem: [
      {
        title: '개인(신용)정보 수집·이용 동의(금융기관)',
        termCd: 'FINANCE_1',
        path: '/terms/FINANCE_1.html',
      },
      {
        title: '개인(신용)정보 제3자 제공 동의(금융기관)',
        termCd: 'FINANCE_2',
        path: '/terms/FINANCE_2.html',
      },
      {
        title: '개인(신용)정보 수집·이용·제공·조회 동의(금융기관)',
        termCd: 'FINANCE_3',
        path: '/terms/FINANCE_3.html',
      },
      {
        title: '고유식별정보 처리 동의(금융기관)',
        termCd: 'FINANCE_4',
        path: '/terms/FINANCE_4.html',
      },
      {
        title: '계약체결 이행 등을 위한 필수 동의(서울보증보험)',
        termCd: 'FINANCE_9',
        path: '/terms/FINANCE_9.html',
      },
    ],
  },
  {
    text: '선택 약관 모두 동의(이벤트 포함)',
    guideText: '',
    required: false,
    termCd: '',
    type: 'termGroup',
    subTextItem: [],
  },
];
